import type { State } from './state'

import state from './state'
import actionTypes from './actionTypes'
import actions from './actions'
import mutations from './mutations'
import recipientDetailList from './modules/recipient-detail-list'
import confirmModal from './modules/confirm-modal'

export { State, actionTypes }

export default {
  namespace: true,
  actions,
  state,
  mutations,

  modules: {
    recipientDetailList,
    confirmModal,
  },
}
